import React from "react"

import SiteContainer from "../SiteContainer"

const NavbarViewWrapper: React.FC<{ children: object }> = ({ children }) => {
  return (
    <nav className="sticky w-full top-0 bg-white shadow" style={{ zIndex: 2 }}>
      <div className="py-3">
        <SiteContainer>
          <div className="flex items-center justify-between">{children}</div>
        </SiteContainer>
      </div>
    </nav>
  )
}

export default NavbarViewWrapper
